import "../phaser.min.js";
import Common from "../Includes/Common.js";

class TriviaInfo extends Phaser.Scene {
    constructor() {
        super('TriviaInfo');
        this.common = new Common();
    }

    init(data) {
        this.totalQuestions = data.totalQuestions || 7;
        this.currentQuestionIndex = data.currentQuestionIndex || 1;
        this.score = data.score || 0;
        this.timeLeft = 10;
        this.timerEvent = null;
    }

    create() {
        const padding = 20;
        const style = {
            fontFamily: this.common.font,
            fontSize: 48,
            color: '#FFFFFF',
            stroke: '#000000',
            strokeThickness: 4
        };

        // Progress Text (e.g., 1/7)
        this.progressText = this.add.text(this.scale.width / 2, this.scale.height / 12, `${this.currentQuestionIndex}/${this.totalQuestions}`, style)
                .setOrigin(0.5, 0.5);

        // Timer Text
        this.timerText = this.add.text(this.scale.width / 2, this.scale.height / 12, `Time: `, style).setOrigin(0.5, 0.5).setAlpha(0);

        // Score Text
        this.scoreText = this.add.text(this.scale.width / 12 * 8, this.scale.height / 12, `Score: ${this.score}`, style).setOrigin(0.5, 0.5);
        this.pointsText = this.add.text(this.scale.width / 12 * 8, this.scale.height / 12 * 1.625, `+ 1000 points`, style).setOrigin(0, 0.5).setAlpha(0);
        this.bonusText = this.add.text(this.scale.width / 12 * 8, this.scale.height / 12 * 2.125, `+ 1000 time bonus`, style).setOrigin(0, 0.5).setAlpha(0);


        // Listen for updates
        const quiz = this.scene.get('Quiz');
        quiz.events.on('update-trivia-info', this.updateInfo, this);
        quiz.events.on('start-timer', this.startTimer, this);
        quiz.events.on('stop-timer', this.stopTimer, this);

        this.events.once('shutdown', () => {
            quiz.events.off('update-trivia-info', this.updateInfo, this);
            quiz.events.off('start-timer', this.startTimer, this);
            quiz.events.off('stop-timer', this.stopTimer, this);
        });
    }

    updateInfo(data) {
        if (!this.progressText || !this.progressText.active || !this.progressText.scene) return;

        if (data.currentQuestionIndex !== undefined) {
            this.currentQuestionIndex = data.currentQuestionIndex;
            this.progressText.setText(`${this.currentQuestionIndex}/${this.totalQuestions}`);
        }
        if (data.score !== undefined) {
            this.score = data.score;
            this.scoreText.setText(`Score: ${this.score}`);
            if(data.noAnims === undefined || data.noAnims !== true) {
                this.tweens.chain({
                    targets: this.pointsText,
                    tweens: [{
                        alpha: 1,
                        duration: 100,
                        y: this.scale.height / 12 * 1.5,
                        ease: 'Linear',
                    }, {
                        alpha: 0,
                        duration: 100,
                        delay: 1800,
                        onComplete: () => {
                            this.pointsText.y = this.scale.height / 12 * 1.625;
                        }
                    }]
                })
            }
        }
        if(data.bonus !== undefined){
            this.bonusText.setText(`+ ${data.bonus} time bonus`);
            this.tweens.chain({
                targets: this.bonusText,
                tweens: [{
                    alpha: 1,
                    duration: 100,
                    delay: 200,
                    y: this.scale.height / 12 * 2,
                    ease: 'Linear',
                },{
                    alpha: 0,
                    duration: 100,
                    delay: 1600,
                    onComplete: () => {
                        this.bonusText.y = this.scale.height / 12 * 2.125;
                    }
                }]
            })
        }
    }

    startTimer() {
        if (!this.timerText || !this.timerText.active || !this.timerText.scene) return;
        this.stopTimer();
        this.timeLeft = 10;
        this.timerText.setText(`Time: ${this.timeLeft}`);
        this.timerText.setColor('#FFFFFF');

        this.timerEvent = this.time.addEvent({
            delay: 1000,
            callback: this.onTick,
            callbackScope: this,
            loop: true
        });
    }

    resetTimer() {
        this.startTimer();
    }

    stopTimer() {
        if (this.timerEvent) {
            this.timerEvent.destroy();
            this.timerEvent = null;
        }
        if (this.timerText && this.timerText.active && this.timerText.scene) {
            this.timerText.setText('');
        }
    }

    onTick() {
        if (!this.timerText || !this.timerText.active || !this.timerText.scene) {
            this.stopTimer();
            return;
        }
        this.timeLeft--;
        if (this.timeLeft <= 0) {
            this.timeLeft = 0;
            this.stopTimer();
            this.timerText.setText('No Time Bonus');
        }else {
            this.timerText.setText(`Time: ${this.timeLeft}`);
        }
    }
}

export default TriviaInfo;
